//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
    useState,
    useCallback,
    useContext,
    useEffect,
} from "react";
import * as moment from "moment";
import { PDFDownloadLink } from "@react-pdf/renderer";

// custom pages
import { useStyles } from "./styles";
import report from "apis/Report/Report";
import Context from "context/context";

// material-ui
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

// material-ui icons
import { useTranslation } from 'react-i18next';
import { enUS, fr } from "date-fns/locale";
import StatementXLSX from "./StatementXLSX";
import StatementPDF from "./StatementPDF";

//Analytics
import { logEvent } from "helpers/analytics";
import {useTrackWithGTM} from 'helpers/gtm';



// custom TextField
const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormLabel-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: 20,
            },
            "&.MuiOutlinedInput-root": {
                marginTop: 0,
                borderRadius: "0px 10px 10px 0px !important",
                height: 40,
            },
        },
    },
})(TextField);


export default function ViewMyStatement(props) {
    const { state, dispatch } = useContext(Context);
    const { page, setDisableDropdown } = props;
    const { annualRewardStatmentAPI } = report();
    const classes = useStyles();
    const { t, i18n } = useTranslation()
    const [states, setstates] = useState({
        selectedYear: "",
        yearsDropDown: [],
        excelData: {},
        pdfData: {},
        response: false,
        eLoading: false,
        pLoading: false,
        excelBtnActive: false,
        pdfBtnActive: false,
        org:state?.userInfo?.loyalty_organization_name,
        lng:i18n.language
    });    
      const { trackWithGTM } = useTrackWithGTM()
useEffect(() => {
    // 🔹 Log page view
    logEvent({
      event_type: "page_view",
      event_name: "View my Statements",
      user_id: state?.userInfo?.user_id,
      session_id: state?.userInfo?.session_id,
    });
  }, []);
    const setStates = useCallback((newState) => {
        setstates((states) => ({ ...states, ...newState }));
    }, []);

    useEffect(() => {
        handleSetYearsDropDown()
    }, []);

    function handleSetYearsDropDown() {
        let arr = [];
        let tempYear =  moment().subtract(1, 'y').format('YYYY')
       
        let stopYear = state?.ALA?.["Loyalty_Account.reactivation_date"]
        ? moment(state?.ALA?.["Loyalty_Account.reactivation_date"]).format('YYYY')
        : "2023";
        arr.push(tempYear);
        while (tempYear != stopYear) {
            tempYear = moment(tempYear).subtract(1, 'y').format('YYYY');
            arr.push(tempYear)
        }
        setStates({ yearsDropDown: arr });
    }

    // CustomerStatus api func
    const handleGetCustomerStatus = async (type) => {
        try {
            setDisableDropdown(true);
            let values = {};
            values = {
                startDate: moment(states.selectedYear).startOf('year').format("MM/DD/YYYY"),
                endDate: moment(states.selectedYear).endOf('year').format("MM/DD/YYYY"),
                loyaltyId: state?.ALA?.loyalty_id,
            };
            let res = await annualRewardStatmentAPI(values);

            if (res && res.data) {
                dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
                if (type === "excel") {
                    setStates({
                        excelData: res?.data,
                        response: true,
                        pLoading:false,
                        eLoading: false,
                    });
                } else if (type === "pdf") {
                    setStates({
                        pdfData: res?.data,
                        response: true,
                        pLoading:false,
                        eLoading: false,
                    });
                }
                setDisableDropdown(false);
                return true;
            }
        } catch (err) {
            console.log(err);
        }
    };

    const locale = i18n.language == 'fr' ? fr : enUS;

    return (
        <div style={{ marginTop: 20 }}>
            <div className={classes.headText}>{t('Annual Rewards Statements')}</div>
            <div className={classes.headText}>
            </div>
            <Grid item style={{ flex: "none", marginTop: 10 }} className="pending-form-gp">
                <React.Fragment>
                    <button
                        type="button"
                        style={{ height: 40, width: "18%", fontSize: 14 }}
                        className={`${classes.dash_1_tab_1} ${classes.earnedBtn}`}
                    >
                        {t("Select Year")}
                    </button>
                </React.Fragment>
                <span>
                    <CssTextField
                        variant="outlined"
                        id={"dropdown"}
                        select
                        type={"text"}
                        className={classes.earnedInput}
                        style={{ height: 40, width: "18%" }}
                        required
                        value={states.selectedYear}
                        onChange={(e) => {setStates({ selectedYear: e.target.value,pdfData: [] })
                        
                    }}
                    >
                        {states?.yearsDropDown?.map(year => <MenuItem value={year} key={year}>
                            {year}
                        </MenuItem>)}
                    </CssTextField>
                </span>

            </Grid>

            {states?.selectedYear && <div className={classes.exportAndPreview}>
                <div className={classes.headText} style={{ marginTop: 20 }}>{states?.selectedYear} Rewards Statement</div>
                {(state?.userInfo?.role_id == 10 || state?.userInfo?.role_id == 3 || state?.userInfo?.role_id == 13) && <Button
                    className={classes.exportBtn}
                    style={{ marginLeft: 0 }}
                    onClick={async () => {
                        logEvent({
                            event_type: "button_click",
                            event_name: "export-excel", 
                            user_id: state?.userInfo?.user_id,
                            session_id: state?.userInfo?.session_id,
                            page_url: window.location.pathname,
                          });
                          trackWithGTM({
                            database: state?.userInfo?.loyalty_organization_name,
                            event: "click",
                            pathname: window.location.pathname,
                            userId: state?.userInfo?.user_id,
                            role_id:state?.userInfo?.role_id,
                            allstate:state
                          });
                        setStates({
                            response: false,
                            excelData: [],
                            eLoading: true,
                            excelBtnActive: true,
                            pdfBtnActive: false,
                        });
                        let res = await handleGetCustomerStatus("excel");
                        if (res) {
                            console.log("csv read")
                            document.getElementById("csv").click();
                        }
                    }}
                    disabled={states.eLoading || states.pLoading}
                >
                    {states.eLoading && states.excelBtnActive ? (
                        <React.Fragment>
                            <CircularProgress
                                style={{ height: 25, width: 25 }}
                                variant="determinate"
                                value={state.reportResCount}
                            />{" "}
                            &nbsp;
                            <span style={{ color: "#305698", fontWeight: "bold" }}>
                                {state.reportResCount == 0 ? (
                                    <div className="snippet">
                                        <div className="stage">
                                            <div className="dot-typing-e"></div>
                                        </div>
                                    </div>
                                ) : (
                                    `${state.reportResCount}%`
                                )}
                            </span>
                        </React.Fragment>
                    ) : (
                        t("Export as excel")
                    )}
                </Button>}
                <StatementXLSX
                    states={states}
                    startDate={moment(states?.selectedYear).startOf('year').format('MMM DD, YYYY')}
                    endDate={moment(states?.selectedYear).endOf('year').format('MMM DD, YYYY')}
                    page={page}
                />
                <Button
                    className={classes.exportBtn}
                    onClick={async () => {
                        logEvent({
                            event_type: "button_click",
                            event_name: "export-PDF", 
                            user_id: state?.userInfo?.user_id,
                            session_id: state?.userInfo?.session_id,
                            page_url: window.location.pathname,
                          });
                          trackWithGTM({
                            database: state?.userInfo?.loyalty_organization_name,
                            event: "click",
                            pathname: window.location.pathname,
                            userId: state?.userInfo?.user_id,
                            role_id:state?.userInfo?.role_id,
                            allstate:state
                          });
                        setStates({
                            response: false,
                            pdfData: [],
                            eLoading: true,
                            excelBtnActive: false,
                            pdfBtnActive: true,
                        });
                        let res = await handleGetCustomerStatus("pdf");
                    }}
                    disabled={states.eLoading || states.pLoading}
                >
                    {states.eLoading && states.pdfBtnActive ? (
                        <React.Fragment>
                            <CircularProgress
                                style={{ height: 25, width: 25 }}
                                variant="determinate"
                                value={state.reportResCount}
                            />{" "}
                            &nbsp;
                            <span style={{ color: "#305698", fontWeight: "bold" }}>
                                {state.reportResCount == 0 ? (
                                    <div className="snippet">
                                        <div className="stage">
                                            <div className="dot-typing-e"></div>
                                        </div>
                                    </div>
                                ) : (
                                    `${state.reportResCount}%`
                                )}
                            </span>
                        </React.Fragment>
                    ) : t(
                        "Export as PDF"
                    )}
                </Button>
                {Object.keys(states.pdfData).length > 0 && states?.pdfBtnActive && (
                    <PDFDownloadLink
                        style={{ display: "none" }}
                        document={
                            <StatementPDF
                                states={states}
                                startDate={moment(states?.selectedYear).startOf('year').format('MMM DD, YYYY')}
                                endDate={moment(states?.selectedYear).endOf('year').format('MMM DD, YYYY')}
                                setStates={setStates}                            
                            />
                        }
                        fileName={
                            `${page.replace(/ /g, "")}` +
                            " " +
                            moment(new Date()).format("MM-DD-YYYY,h:mm A")
                        }
                    >
                        <button id="download-pdf"></button>
                    </PDFDownloadLink>
                )}
                {(states.eLoading || states.pLoading) && <div style={{ color: 'red', marginLeft: 10 }}>*Please wait don't reload the page, system is processing</div>}
            </div>}
        </div>
    );
}
